import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DetailsState, TabDataType } from "../types";
import { OVERVIEW_TAB } from "../../app/appConstants";

export const initialState: DetailsState = {
  selectedTab: OVERVIEW_TAB
};

const slice = createSlice({
  name: "details",
  initialState,
  reducers: {
    setSelectedTab(state, action: PayloadAction<TabDataType>) {
      state.selectedTab = action.payload;
    }
  }
});

const { reducer, actions } = slice;
export const { setSelectedTab } = actions;
export default reducer;
